import {Type} from 'class-transformer';
import {BaseCollectionModel, FileUploadRes} from '@yasc/yasc-material-components';
import {BankAccountRes} from './bank.contract';
import {CompanyDetailsMinRes} from './company.contract';
import {UserDetailsMinRes} from './user.contract';
import {InvoiceAddressRes, InvoiceDetailRes, PositionCreateReq, PositionDetailRes} from './invoice.contract';

export type OfferStatus = 'draft' | 'finalized' | 'sent' | 'accepted' | 'rejected' | 'expired' | 'cancelled';

export class OfferDetailRes {
    id!: number;
    version = 1;
    offerNumber = '';
    status: OfferStatus = 'draft';
    offerDate!: string;
    validUntil!: string;
    created!: string;
    sentDate?: string | null;
    finalizedAt?: string | null;
    acceptedAt?: string | null;
    rejectedAt?: string | null;
    cancelledAt?: string | null;
    totalNetto = 0;
    totalMwst = 0;
    totalBrutto = 0;
    projectId?: number | null;
    projectName = '';
    paymentAddressId?: number | null;
    subject = '';
    customerReference = '';
    introText = '';
    closingText = '';
    internalNote = '';
    paymentTermsText = '';
    paymentTermsDays = 30;
    paymentDiscountPercent?: number | null;
    paymentDiscountDays?: number | null;
    budgetBasis = 'manual';
    hourlyRate = 0;
    selectedTaskIds: string[] = [];
    selectedMemberIds: number[] = [];
    attachment?: FileUploadRes | null;
    bankAccount?: BankAccountRes | null;
    company?: CompanyDetailsMinRes | null;
    companyContact?: UserDetailsMinRes | null;
    sellerCompany?: CompanyDetailsMinRes | null;
    sellerContact?: UserDetailsMinRes | null;
    paymentAddress?: InvoiceAddressRes | null;
    sellerAddress?: InvoiceAddressRes | null;
    @Type(() => PositionDetailRes)
    positions: PositionDetailRes[] = [];
    invoiceIds: number[] = [];
}

export class OfferCreateReq {
    offerDate?: Date;
    validUntil!: Date;
    buyerContactId!: number;
    companyId!: number;
    paymentAddressId!: number;
    sellerContactId?: number | null;
    bankAccountId?: string | null;
    productId?: string | null;
    projectId?: number | null;
    subject = '';
    customerReference = '';
    introText = '';
    closingText = '';
    internalNote = '';
    paymentTermsText = '';
    paymentTermsDays = 30;
    paymentDiscountPercent?: number | null;
    paymentDiscountDays?: number | null;
    budgetBasis = 'manual';
    hourlyRate = 0;
    selectedTaskIds: string[] = [];
    selectedMemberIds: number[] = [];
    positions: PositionCreateReq[] = [];
}

export class OfferUpdateReq {
    buyerContactId?: number;
    companyId?: number;
    paymentAddressId?: number;
    sellerContactId?: number | null;
    bankAccountId?: string | null;
    projectId?: number | null;
    offerDate?: Date;
    validUntil?: Date;
    subject?: string;
    customerReference?: string;
    introText?: string;
    closingText?: string;
    internalNote?: string;
    paymentTermsText?: string;
    paymentTermsDays?: number;
    paymentDiscountPercent?: number | null;
    paymentDiscountDays?: number | null;
    budgetBasis?: string;
    hourlyRate?: number;
    selectedTaskIds?: string[];
    selectedMemberIds?: number[];
    positions?: PositionCreateReq[];
    version?: number;
}

export class OfferProjectSourceReq {
    projectId!: number;
    groupBy: 'project' | 'budget' | 'hours' | 'task' | 'member' = 'project';
    hourlyRate = 0;
    taxPercent = 19;
    defaultHours = 1;
    taskIds: string[] = [];
    memberIds: number[] = [];
}

export class OfferSourceOptionRes<T = string | number> {
    id!: T;
    name = '';
}

export class OfferProjectSourceRes {
    projectId!: number;
    projectName = '';
    customerId!: number;
    customerName = '';
    projectVolumeBrutto?: number | null;
    @Type(() => OfferSourceOptionRes)
    tasks: OfferSourceOptionRes<string>[] = [];
    @Type(() => OfferSourceOptionRes)
    members: OfferSourceOptionRes<number>[] = [];
    @Type(() => PositionCreateReq)
    positions: PositionCreateReq[] = [];
}

export class OfferDecisionReq { date?: Date; }
export class OfferSendReq { receivers: string[] = []; }
export type OfferCollectionRes = BaseCollectionModel<OfferDetailRes>;
export type OfferInvoiceDraftRes = InvoiceDetailRes;
